module.exports = __webpack_public_path__ + "static/media/a-storeBtn.a283c269.png";